import { ServiceBase, Result } from "./ServiceBase";
import { Code } from '../models/Code';

export default class CodeService extends ServiceBase {

    public static async list(attributeId: string): Promise<Result<Code[]>> {

        var result = await this.requestJson<Code[]>({
            url: `/api/Code/list/${attributeId}`,
            method: "GET"            
        });

        return result;
    }

    public static async save(model: Code): Promise<Result<Code>> {

        var result = await this.requestJson<Code>({
            url: `/api/Code/save`,
            method: "POST",
            data: model
        });

        if (!result.hasErrors) {

            result = await CodeService.get(model.Id);
        }

        return result;
    }

    public static async get(id: string): Promise<Result<Code>> {

        var result = await this.requestJson<Code>({
            url: `/api/Code/${id}`,
            method: "GET"
        });
        return result;
    }
}
